module.exports = __webpack_public_path__ + "img/school.efc6637c.svg";